<template>
  <div style="padding-bottom: 200px;">
    <div v-if="!loading">
      <v-container mt-3 style="max-width: 800px;">
        <v-layout row justify-center wrap text-xs-center>
          <v-flex xs12 my-3>
            <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.666645 7C0.666645 3.54822 3.65037 0.75 7.33098 0.75L20.669 0.75C24.3496 0.75 27.3333 3.54822 27.3333 7C27.3333 10.4518 24.3496 13.25 20.669 13.25L7.33098 13.25C3.65037 13.25 0.666645 10.4518 0.666645 7Z" fill="#E91E63"/>
            </svg>
          </v-flex>
          <v-flex xs12 my-3 class="navy--text desktop-h1">
            Manipulatives
          </v-flex>
        </v-layout>
      </v-container>
      <v-container text-xs-center max_w v-if="hasBundle">
        <v-layout justify-center>
          <v-flex xs12>
            <ManipulativeIconsView :scope="scope"/>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-else>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 text-xs-center>
            <v-progress-circular
              :size="70"
              :width="7"
              color="secondary"
              indeterminate
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-dialog v-model="showFeaturePreview" width="1280">
      <v-layout wrap white>
        <v-flex xs12 v-if="showFeaturePreview">
          <video controls style="width:100%; display:block" src="https://media.brainingcamp.com/v/848323422.mp4"></video>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
import ManipulativeIconsView from '@/components/ManipulativeIconsView'
import OauthService from '@/services/OauthService'

export default {
  data: function () {
    return {
      showWebinar: true,
      scope: null,
      loading: true,
      hasBundle: true,
      shareCode: '',
      showFeaturePreview: false
    }
  },
  components: {
    ManipulativeIconsView
  },
  computed: {
    shareCodeIsValid: function () {
      if (this.shareCode.length === 8) return true;
      return false;
    },
    isStudent: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.role === 'student';
      }
      return false;
    }
  },
  methods: {
    submitShareCode: function () {
      if (!this.shareCodeIsValid) return;

      const code = this.shareCode;

      this.$router.push({
        path: '/s/' + code
      })
    },
  },
  mounted: async function () {
    this.loading = true

    if (!this.$store.getters.user) {
      try {
        const response = await OauthService.refreshToken()
        
        if (response.data.token) {
          this.$store.dispatch('setToken', response.data.token)
          this.$store.dispatch('setUser', response.data.user)
        }
      } catch (err) {
        this.$router.push({
          path: '/logout'
        })
        return
      }
    }

    this.scope = this.$store.getters.user.scope
    if (this.scope === '*') {
      this.hasBundle = true;
    } else {
      this.$router.push({
        path: '/pricing'
      })
    }
    this.loading = false
  }
}
</script>

<style scoped>
.webinar-card {
  width: 280px;
  background: white;
  border: 2px solid #D7EBFF;
  border-radius: 18px;
  padding: 24px;
}

.max_w {
  max-width: 1200px;
}


.codeInput >>> input {
  text-transform: uppercase;
}
</style>
